export enum ZoneType {
  ZoneA = 'Zon-A',
  ZoneB = 'Zon-B',
  ZoneC = 'Zon-C',
}
